export function dadosAgenteMapper(dados: string): {
  state: string;
  data: {};
} {
  if (dados) {
    if (dados[0] !== '0' && dados.length > 2 && dados.length > 2 && `${dados[0]}${dados[1]}` !== '44') {
      const index = dados.indexOf('[');
      if (index) {
        const dataString = dados.slice(index + 1);
        const dataArray = JSON.parse('[' + dataString);

        return { state: dataArray[0], data: dataArray[1] };
      }
    }
  }
  return { state: 'agent-not-data', data: {} };
}
